import { tss } from "tss-react";
import { trackColors } from "renderers/ItemRenderer";
import { TableChart, Tv } from "@mui/icons-material";
import { ReactComponent as Voxsurf } from "assets/images/voxsurf.svg";
import { ReactComponent as Voxgen } from "assets/images/voxgen.svg";
import { ReactComponent as Voxmesh } from "assets/images/voxmesh.svg";
import { ReactComponent as Voxbm } from "assets/images/voxbm.svg";
import { ReactComponent as Ortho } from "assets/images/ortho.svg";
import { ReactComponent as Voxdh } from "assets/images/idxdh.svg";
import { ReactComponent as RawFile } from "assets/images/file.svg";
import { iconColor } from "styles/common";

const useStyles = tss.create((theme) => ({
    icons: {
        width: 26,
        marginRight: 5,
        borderRadius: 14,
        padding: 3,
    },
}));

const Icons = (fileName: string, showBackground?: boolean, className?: any) => {
    const { classes, cx } = useStyles();
    if (typeof showBackground === "undefined") {
        showBackground = true;
    }
    var Component: any;

    switch (fileName) {
        case "voxbm":
            Component = Voxbm;
            break;
        case "voxsurf":
            Component = Voxsurf;
            break;
        case "voxgen":
            Component = Voxgen;
            break;
        case "voxmesh":
        case "voxemesh":
            Component = Voxmesh;
            break;
        case "ortho":
            Component = Ortho;
            break;
        case "voxdh":
            Component = Voxdh;
            break;
        case "meshset":
            Component = Voxmesh;
            break;
        case "file":
            Component = RawFile;
            break;
        case "view":
            return <Tv className={classes.icons} />;
        case "report":
            return <TableChart className={classes.icons} />;
        default:
            Component = Voxbm;
            break;
    }
    return (
        <Component
            className={cx(className ? className : classes.icons)}
            style={{ color: iconColor, backgroundColor: showBackground ? trackColors[fileName] : "" }}
        />
    );
};
export default function FileIcon(props: { icon: string; showBackground?: boolean; className?: any }) {
    const { icon, showBackground, className } = props;
    return Icons(icon, showBackground, className);
}
